import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const reactionWrapper = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: Spacing.XS,
})
